<p-toast></p-toast>
<div class="container-fluid template-popup" style="overflow-x: hidden; max-width: 100%; box-sizing: border-box; position: relative;">
  @if (formLoading) {
    <div class="task-loading-overlay">
      <div class="loading-content">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #3b82f6;"></i>
        <p style="margin-top: 1rem; font-size: 1rem; color: #6b7280; font-weight: 500;">Loading template...</p>
      </div>
    </div>
  }

  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="d-flex justify-content-between align-items-center my-2">
      <h4>{{data?.title || 'Template'}} @if (templateId) {
        <span>#{{templateId}}</span>
      }</h4>
      <div class="d-flex gap-2">
        <button mat-button type="button" (click)="close()">Cancel</button>
        <button mat-raised-button color="primary" (click)="formSave()" [disabled]="formLoading">
          {{templateId ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label class="form-label fw-bold">Template Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter template name"
            [class.is-invalid]="form1.get('name').invalid && (form1.get('name').dirty || form1.get('name').touched)">
          @for (validation of validationMessages.name; track validation) {
            <div>
              @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                <small class="text-danger d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Description</label>
          <textarea class="form-control" formControlName="description" rows="3" placeholder="Enter template description"></textarea>
        </div>

        <div class="mb-3">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Active</label>
          </div>
        </div>

        <!-- <div *ngIf="templateId" class="mb-3"> -->
        <div class="mb-3">
          <div class="mb-3">
            <h5 class="mb-2">Template Tasks</h5>
            <div class="mb-2">
              <app-task-search [selectedTask]="selectedTaskForTemplate" [forSearchBar]="true"
              (onTaskSelected)="onTaskSelected($event)"></app-task-search>
            </div>
          </div>
          @if (templateTasks.length === 0) {
            <div class="text-muted p-3 border rounded">
              No tasks added yet. Search and select tasks above to add them to this template.
            </div>
          }
          @if (templateTasks.length > 0) {
            <div class="list-group">
              @for (task of templateTasks; track task; let i = $index) {
                <div class="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{i + 1}}. {{task.name}}</strong>
                    @if (task.description) {
                      <div class="text-muted small"><span [innerHTML]="task.description"></span></div>
                    }
                  </div>
                  <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger"
                  (click)="deleteTask(task)" pTooltip="Delete Task"></button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

